import UIIcon from 'UIComponents/icon/UIIcon';
import Small from 'UIComponents/elements/Small';
import { getFileUploadErrorMessage } from '../utils';
import UIIconButton from 'UIComponents/button/UIIconButton';
import StyledFileValueContainer from '../StyledFileValueContainer';
import StyledUIFileAttachment from '../StyledUIFileAttachment';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { useHasNoUploadLimit } from '../../v2/hooks/useHasNoUploadLimit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FileDraftErrorsListItem = ({
  file,
  errorType,
  onRemove
}) => {
  const hasNoUploadLimit = useHasNoUploadLimit();
  const tooltip = getFileUploadErrorMessage(errorType, hasNoUploadLimit);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledFileValueContainer, {
      withError: true,
      children: [/*#__PURE__*/_jsx(StyledUIFileAttachment, {
        fileName: /*#__PURE__*/_jsx(UITruncateString, {
          children: file.name
        }),
        size: "small",
        renderPreview: () => /*#__PURE__*/_jsx(UIIcon, {
          name: "question"
        }),
        "data-test-id": "file-attachment-with-error"
      }), /*#__PURE__*/_jsx(UIIconButton, {
        size: "small",
        use: "link",
        onClick: () => onRemove(file),
        style: {
          flexShrink: '0'
        },
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "remove",
          size: 12,
          "data-test-id": "file-attachment-with-error-remove-icon"
        })
      })]
    }), /*#__PURE__*/_jsx(UITruncateString, {
      tooltip: tooltip,
      children: /*#__PURE__*/_jsx(Small, {
        use: "error",
        weight: "medium",
        children: tooltip
      })
    })]
  });
};
export default FileDraftErrorsListItem;